import { SVGProps } from 'react';

type Title = {
  title?: string;
};
type IconProps = Partial<SVGProps<SVGSVGElement>> & Title;

const Icons = {
  QuipliLogo: (props: IconProps) => (
    <svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.98081 0.536133H20.6329C20.9635 0.556164 21.2257 0.829633 21.2277 1.16477V5.6058C21.2277 5.95576 21.5114 6.23946 21.8613 6.23946H25.9802C25.9869 6.23946 25.9936 6.23936 26.0003 6.23915C26.3386 6.24967 26.6101 6.52544 26.6138 6.86548V21.1302C26.6138 21.4801 26.8975 21.7638 27.2475 21.7638H32L32 0.536133V21.7647H31.3664C31.7138 21.7647 31.9959 22.0442 32 22.3906V26.8447C31.9933 27.1888 31.7122 27.4658 31.3665 27.4658L28.515 27.4658V27.4668H27.2162C26.8809 27.4504 26.614 27.1733 26.614 26.8339V23.9824H26.6138V22.3967C26.6138 22.0468 26.3301 21.7631 25.9802 21.7631H21.8613C21.5114 21.7631 21.2277 22.0468 21.2277 22.3967V26.8394C21.2248 27.1763 20.959 27.4505 20.6255 27.4668H5.98833C5.65297 27.4504 5.38611 27.1733 5.38611 26.8339L5.38611 23.9824H5.38609V22.3967C5.38609 22.0468 5.10239 21.7631 4.75242 21.7631H0.596394C0.267501 21.744 0.0058865 21.4742 0 21.1419V9.72399H0.000162363L0.000162612 6.8725C0.000162642 6.53093 0.270427 6.25248 0.60878 6.23932H4.75262C5.10258 6.23932 5.38628 5.95562 5.38628 5.60566V1.1521C5.39471 0.822762 5.65442 0.555911 5.98081 0.536133ZM26.6138 5.28765V0.536133H26.6138V5.28765H26.6138ZM26.6138 6.23814H26.0214C26.0171 6.23842 26.0129 6.23865 26.0086 6.23884H26.6138V6.23814ZM5.38616 7.18994C5.38616 6.49001 5.95356 5.92261 6.65349 5.92261H19.9604C20.6603 5.92261 21.2277 6.49001 21.2277 7.18994V20.8137C21.2277 21.5136 20.6603 22.081 19.9604 22.081H6.65349C5.95356 22.081 5.38616 21.5136 5.38616 20.8137V7.18994Z"
        fill="#FDFDFD"
        stroke="none"
      />
    </svg>
  ),
  ListView: (props: IconProps) => (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.5 13.5833C16.9142 13.5833 17.25 13.2475 17.25 12.8333C17.25 12.4191 16.9142 12.0833 16.5 12.0833V13.5833ZM1.5 12.0833C1.08579 12.0833 0.75 12.4191 0.75 12.8333C0.75 13.2475 1.08579 13.5833 1.5 13.5833V12.0833ZM16.5 10.25C16.9142 10.25 17.25 9.91417 17.25 9.49996C17.25 9.08575 16.9142 8.74996 16.5 8.74996V10.25ZM1.5 8.74996C1.08579 8.74996 0.75 9.08575 0.75 9.49996C0.75 9.91417 1.08579 10.25 1.5 10.25V8.74996ZM16.5 12.0833H1.5V13.5833H16.5V12.0833ZM16.5 8.74996H1.5V10.25H16.5V8.74996ZM3.16667 1.91663H14.8333V0.416626H3.16667V1.91663ZM15.75 2.83329V4.49996H17.25V2.83329H15.75ZM14.8333 5.41663H3.16667V6.91663H14.8333V5.41663ZM2.25 4.49996V2.83329H0.75V4.49996H2.25ZM3.16667 5.41663C2.66041 5.41663 2.25 5.00622 2.25 4.49996H0.75C0.75 5.83465 1.83198 6.91663 3.16667 6.91663V5.41663ZM15.75 4.49996C15.75 5.00622 15.3396 5.41663 14.8333 5.41663V6.91663C16.168 6.91663 17.25 5.83465 17.25 4.49996H15.75ZM14.8333 1.91663C15.3396 1.91663 15.75 2.32703 15.75 2.83329H17.25C17.25 1.4986 16.168 0.416626 14.8333 0.416626V1.91663ZM3.16667 0.416626C1.83198 0.416626 0.75 1.4986 0.75 2.83329H2.25C2.25 2.32703 2.66041 1.91663 3.16667 1.91663V0.416626Z"
        stroke="var(--grey-500)"
        fill="var(--grey-500)"
        strokeWidth="0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  HamburguerMenu: (props: IconProps) => (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M1 7L15 7M1 1L19 1M1 13L19 13"
        stroke="#F4EBFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Support: (props: IconProps) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M6.375 14.25H6C3 14.25 1.5 13.5 1.5 9.75V6C1.5 3 3 1.5 6 1.5H12C15 1.5 16.5 3 16.5 6V9.75C16.5 12.75 15 14.25 12 14.25H11.625C11.3925 14.25 11.1675 14.3625 11.025 14.55L9.9 16.05C9.405 16.71 8.595 16.71 8.1 16.05L6.975 14.55C6.855 14.385 6.5775 14.25 6.375 14.25Z"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.9973 8.25H12.0041" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.99661 8.25H9.00335" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.99588 8.25H6.00262" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  AlertTriangle: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z"
        stroke="#DC6803"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  FloppySave: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.83333 1.5V4.33333C4.83333 4.80004 4.83333 5.0334 4.92416 5.21166C5.00406 5.36846 5.13154 5.49594 5.28834 5.57584C5.4666 5.66667 5.69996 5.66667 6.16667 5.66667H11.8333C12.3 5.66667 12.5334 5.66667 12.7117 5.57584C12.8685 5.49594 12.9959 5.36846 13.0758 5.21166C13.1667 5.0334 13.1667 4.80004 13.1667 4.33333V2.33333M13.1667 16.5V11.1667C13.1667 10.7 13.1667 10.4666 13.0758 10.2883C12.9959 10.1315 12.8685 10.0041 12.7117 9.92416C12.5334 9.83333 12.3 9.83333 11.8333 9.83333H6.16667C5.69996 9.83333 5.4666 9.83333 5.28834 9.92416C5.13154 10.0041 5.00406 10.1315 4.92416 10.2883C4.83333 10.4666 4.83333 10.7 4.83333 11.1667V16.5M16.5 6.77124V12.5C16.5 13.9001 16.5 14.6002 16.2275 15.135C15.9878 15.6054 15.6054 15.9878 15.135 16.2275C14.6002 16.5 13.9001 16.5 12.5 16.5H5.5C4.09987 16.5 3.3998 16.5 2.86502 16.2275C2.39462 15.9878 2.01217 15.6054 1.77248 15.135C1.5 14.6002 1.5 13.9001 1.5 12.5V5.5C1.5 4.09987 1.5 3.3998 1.77248 2.86502C2.01217 2.39462 2.39462 2.01217 2.86502 1.77248C3.3998 1.5 4.09987 1.5 5.5 1.5H11.2288C11.6364 1.5 11.8402 1.5 12.0321 1.54605C12.2021 1.58688 12.3647 1.65422 12.5138 1.7456C12.682 1.84867 12.8261 1.9928 13.1144 2.28105L15.719 4.88562C16.0072 5.17387 16.1513 5.318 16.2544 5.48619C16.3458 5.63531 16.4131 5.79789 16.4539 5.96795C16.5 6.15976 16.5 6.36358 16.5 6.77124Z"
        stroke="#1D252C"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  SideBar: (props: IconProps) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M5.75 1.25V14.75M4.85 1.25H11.15C12.4101 1.25 13.0402 1.25 13.5215 1.49524C13.9448 1.71095 14.289 2.05516 14.5048 2.47852C14.75 2.95982 14.75 3.58988 14.75 4.85V11.15C14.75 12.4101 14.75 13.0402 14.5048 13.5215C14.289 13.9448 13.9448 14.289 13.5215 14.5048C13.0402 14.75 12.4101 14.75 11.15 14.75H4.85C3.58988 14.75 2.95982 14.75 2.47852 14.5048C2.05516 14.289 1.71095 13.9448 1.49524 13.5215C1.25 13.0402 1.25 12.4101 1.25 11.15V4.85C1.25 3.58988 1.25 2.95982 1.49524 2.47852C1.71095 2.05516 2.05516 1.71095 2.47852 1.49524C2.95982 1.25 3.58988 1.25 4.85 1.25Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Dashboard: (props: IconProps) => (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M15.5 7.175V2.075C15.5 0.95 15.02 0.5 13.8275 0.5H10.7975C9.605 0.5 9.125 0.95 9.125 2.075V7.175C9.125 8.3 9.605 8.75 10.7975 8.75H13.8275C15.02 8.75 15.5 8.3 15.5 7.175Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 13.925V12.575C15.5 11.45 15.02 11 13.8275 11H10.7975C9.605 11 9.125 11.45 9.125 12.575V13.925C9.125 15.05 9.605 15.5 10.7975 15.5H13.8275C15.02 15.5 15.5 15.05 15.5 13.925Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 8.825V13.925C6.875 15.05 6.395 15.5 5.2025 15.5H2.1725C0.98 15.5 0.5 15.05 0.5 13.925V8.825C0.5 7.7 0.98 7.25 2.1725 7.25H5.2025C6.395 7.25 6.875 7.7 6.875 8.825Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 2.075V3.425C6.875 4.55 6.395 5 5.2025 5H2.1725C0.98 5 0.5 4.55 0.5 3.425V2.075C0.5 0.95 0.98 0.5 2.1725 0.5H5.2025C6.395 0.5 6.875 0.95 6.875 2.075Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ShoppingBag: (props: IconProps) => (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M11.0003 5.75V3.5C11.0003 1.84315 9.65713 0.5 8.00028 0.5C6.34342 0.5 5.00028 1.84315 5.00028 3.5V5.75M1.69428 6.76397L1.24428 11.564C1.11633 12.9287 1.05236 13.6111 1.27881 14.1382C1.47775 14.6012 1.82637 14.984 2.26879 15.2253C2.77242 15.5 3.4578 15.5 4.82856 15.5H11.172C12.5428 15.5 13.2281 15.5 13.7318 15.2253C14.1742 14.984 14.5228 14.6012 14.7217 14.1382C14.9482 13.6111 14.8842 12.9287 14.7563 11.564L14.3063 6.76397C14.1982 5.61151 14.1442 5.03528 13.885 4.59962C13.6568 4.21594 13.3195 3.90883 12.9162 3.71738C12.4583 3.5 11.8795 3.5 10.722 3.5L5.27856 3.5C4.12104 3.5 3.54229 3.5 3.08434 3.71738C2.68103 3.90883 2.34378 4.21594 2.11552 4.59962C1.85634 5.03528 1.80232 5.61151 1.69428 6.76397Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Customer: (props: IconProps) => (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M15.5 14.75V13.25C15.5 11.8521 14.5439 10.6775 13.25 10.3445M10.625 1.46807C11.7244 1.91311 12.5 2.99098 12.5 4.25C12.5 5.50902 11.7244 6.58689 10.625 7.03193M11.75 14.75C11.75 13.3522 11.75 12.6533 11.5216 12.1019C11.2172 11.3669 10.6331 10.7828 9.89805 10.4784C9.34674 10.25 8.64783 10.25 7.25 10.25H5C3.60218 10.25 2.90326 10.25 2.35195 10.4784C1.61687 10.7828 1.03284 11.3669 0.728361 12.1019C0.5 12.6533 0.5 13.3522 0.5 14.75M9.125 4.25C9.125 5.90685 7.78185 7.25 6.125 7.25C4.46815 7.25 3.125 5.90685 3.125 4.25C3.125 2.59315 4.46815 1.25 6.125 1.25C7.78185 1.25 9.125 2.59315 9.125 4.25Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  AddCustomer: (props: IconProps) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M8 10.625H4.625C3.57833 10.625 3.05499 10.625 2.62914 10.7542C1.67034 11.045 0.92003 11.7953 0.62918 12.7541C0.5 13.18 0.5 13.7033 0.5 14.75M13.25 14.75V10.25M11 12.5H15.5M9.875 4.625C9.875 6.48896 8.36396 8 6.5 8C4.63604 8 3.125 6.48896 3.125 4.625C3.125 2.76104 4.63604 1.25 6.5 1.25C8.36396 1.25 9.875 2.76104 9.875 4.625Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Inventory: (props: IconProps) => (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M1.25 4.85C1.25 3.58988 1.25 2.95982 1.49524 2.47852C1.71095 2.05516 2.05516 1.71095 2.47852 1.49524C2.95982 1.25 3.58988 1.25 4.85 1.25H11.15C12.4101 1.25 13.0402 1.25 13.5215 1.49524C13.9448 1.71095 14.289 2.05516 14.5048 2.47852C14.75 2.95982 14.75 3.58988 14.75 4.85V11.15C14.75 12.4101 14.75 13.0402 14.5048 13.5215C14.289 13.9448 13.9448 14.289 13.5215 14.5048C13.0402 14.75 12.4101 14.75 11.15 14.75H4.85C3.58988 14.75 2.95982 14.75 2.47852 14.5048C2.05516 14.289 1.71095 13.9448 1.49524 13.5215C1.25 13.0402 1.25 12.4101 1.25 11.15V4.85Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.36914 6.34375H11.3223" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.5 6.34375L4.92188 6.76562L6.1875 5.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.36914 10.0312H11.3223" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.5 10.0312L4.92188 10.4531L6.1875 9.1875" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Report: (props: IconProps) => (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M7.25 2.99919H4.1C2.83988 2.99919 2.20982 2.99919 1.72852 3.24443C1.30516 3.46014 0.96095 3.80435 0.745235 4.22772C0.5 4.70902 0.5 5.33908 0.5 6.59919V12.8992C0.5 14.1593 0.5 14.7894 0.745235 15.2707C0.96095 15.694 1.30516 16.0382 1.72852 16.254C2.20982 16.4992 2.83988 16.4992 4.1 16.4992H10.4C11.6601 16.4992 12.2902 16.4992 12.7715 16.254C13.1948 16.0382 13.539 15.694 13.7548 15.2707C14 14.7894 14 14.1593 14 12.8992V9.74919M4.99998 11.9992H6.25589C6.62277 11.9992 6.80622 11.9992 6.97885 11.9577C7.1319 11.921 7.27822 11.8604 7.41243 11.7782C7.5638 11.6854 7.69352 11.5557 7.95294 11.2963L15.125 4.12419C15.7463 3.50287 15.7463 2.49551 15.125 1.87419C14.5037 1.25287 13.4963 1.25287 12.875 1.87419L5.70293 9.04625C5.4435 9.30568 5.31378 9.43539 5.22102 9.58677C5.13878 9.72098 5.07817 9.86729 5.04143 10.0203C4.99998 10.193 4.99998 10.3764 4.99998 10.7433V11.9992Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Customizations: (props: IconProps) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}

      <path
        d="M2.25 6L11.25 6M11.25 6C11.25 7.24264 12.2574 8.25 13.5 8.25C14.7426 8.25 15.75 7.24264 15.75 6C15.75 4.75736 14.7426 3.75 13.5 3.75C12.2574 3.75 11.25 4.75736 11.25 6ZM6.75 12L15.75 12M6.75 12C6.75 13.2426 5.74264 14.25 4.5 14.25C3.25736 14.25 2.25 13.2426 2.25 12C2.25 10.7574 3.25736 9.75 4.5 9.75C5.74264 9.75 6.75 10.7574 6.75 12Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ExportImport: (props: IconProps) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path d="M13.3752 9.24219L9.61768 13.0072" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M0.625 9.24219H13.375" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M0.625 4.75719L4.3825 0.992188" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.375 4.75781H0.625" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Settings: (props: IconProps) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M2.25 6.83203V11.1595C2.25 12.7495 2.25 12.7495 3.75 13.762L7.875 16.147C8.4975 16.507 9.51 16.507 10.125 16.147L14.25 13.762C15.75 12.7495 15.75 12.7495 15.75 11.167V6.83203C15.75 5.24953 15.75 5.24953 14.25 4.23703L10.125 1.85203C9.51 1.49203 8.4975 1.49203 7.875 1.85203L3.75 4.23703C2.25 5.24953 2.25 5.24953 2.25 6.83203Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  AddDocument: (props: IconProps) => (
    <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M14.6667 8.24935V5.16602C14.6667 3.76588 14.6667 3.06582 14.3942 2.53104C14.1545 2.06063 13.7721 1.67818 13.3017 1.4385C12.7669 1.16602 12.0668 1.16602 10.6667 1.16602H5.33337C3.93324 1.16602 3.23318 1.16602 2.6984 1.4385C2.22799 1.67818 1.84554 2.06063 1.60586 2.53104C1.33337 3.06582 1.33337 3.76588 1.33337 5.16602V13.8327C1.33337 15.2328 1.33337 15.9329 1.60586 16.4677C1.84554 16.9381 2.22799 17.3205 2.6984 17.5602C3.23318 17.8327 3.93324 17.8327 5.33337 17.8327H8.00004M9.66671 8.66602H4.66671M6.33337 11.9993H4.66671M11.3334 5.33268H4.66671M13 16.9993V11.9993M10.5 14.4993H15.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Edit: (props: IconProps) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M13.9999 7.33326L10.6666 3.99993M1.08325 16.9166L3.90356 16.6032C4.24813 16.5649 4.42042 16.5458 4.58146 16.4937C4.72433 16.4474 4.86029 16.3821 4.98566 16.2994C5.12696 16.2062 5.24954 16.0836 5.49469 15.8385L16.4999 4.83326C17.4204 3.91279 17.4204 2.4204 16.4999 1.49993C15.5795 0.579452 14.0871 0.579451 13.1666 1.49992L2.16136 12.5052C1.91621 12.7503 1.79363 12.8729 1.70045 13.0142C1.61778 13.1396 1.55243 13.2755 1.50618 13.4184C1.45405 13.5794 1.43491 13.7517 1.39662 14.0963L1.08325 16.9166Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Close: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path d="M18 6L6 18M6 6L18 18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  NotStarted: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <circle cx="10" cy="10" r="9" strokeWidth="2" />
    </svg>
  ),
  InProgress: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M10 14.9286C10 15.4809 10.4508 15.9372 10.9954 15.8455C12.2175 15.6399 13.3548 15.0591 14.2426 14.1713C15.3679 13.0461 16 11.5199 16 9.92865C16 8.33735 15.3679 6.81123 14.2426 5.68601C13.3548 4.79821 12.2175 4.21736 10.9954 4.01177C10.4508 3.92015 10 4.37636 10 4.92865L10 9.92865L10 14.9286Z"
        fill={props.stroke}
        stroke="none"
      />
      <circle cx="10" cy="10" r="9" strokeWidth="2" />
    </svg>
  ),
  Complete: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M18.3332 9.23806V10.0047C18.3321 11.8017 17.7503 13.5503 16.6743 14.9896C15.5983 16.4289 14.0859 17.4818 12.3626 17.9913C10.6394 18.5008 8.79755 18.4396 7.1119 17.8169C5.42624 17.1941 3.98705 16.0431 3.00897 14.5356C2.03089 13.0281 1.56633 11.2448 1.68457 9.45166C1.80281 7.65853 2.49751 5.95167 3.66507 4.58562C4.83263 3.21958 6.41049 2.26755 8.16333 1.87152C9.91617 1.47549 11.7501 1.65668 13.3915 2.38806M18.3332 3.33329L9.99984 11.675L7.49984 9.17496"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Search: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M19 19L14.65 14.65M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Export: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M19 10V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V10M14 5L10 1M10 1L6 5M10 1V13"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ThinDownload: () => (
    <svg width="12" height="14" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 5.5L4 8.5M4 8.5L1 5.5M4 8.5V1.5"
        stroke="black"
        stroke-opacity="0.4"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  Add: (props: IconProps) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path d="M8 1V15M1 8H15" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  DotsVertical: (props: IconProps) => (
    <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path d="M2 10C2.55228 10 3 9.55228 3 9C3 8.44772 2.55228 8 2 8C1.44772 8 1 8.44772 1 9C1 9.55228 1.44772 10 2 10Z" />
      <path d="M2 3C2.55228 3 3 2.55228 3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3Z" />
      <path d="M2 17C2.55228 17 3 16.5523 3 16C3 15.4477 2.55228 15 2 15C1.44772 15 1 15.4477 1 16C1 16.5523 1.44772 17 2 17Z" />
      <path
        d="M2 10C2.55228 10 3 9.55228 3 9C3 8.44772 2.55228 8 2 8C1.44772 8 1 8.44772 1 9C1 9.55228 1.44772 10 2 10Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 3C2.55228 3 3 2.55228 3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 17C2.55228 17 3 16.5523 3 16C3 15.4477 2.55228 15 2 15C1.44772 15 1 15.4477 1 16C1 16.5523 1.44772 17 2 17Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  DotsHorizontal: (props: IconProps) => (
    <svg width="18" height="4" viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path d="M9 3C9.55228 3 10 2.55228 10 2C10 1.44772 9.55228 1 9 1C8.44772 1 8 1.44772 8 2C8 2.55228 8.44772 3 9 3Z" />
      <path d="M16 3C16.5523 3 17 2.55228 17 2C17 1.44772 16.5523 1 16 1C15.4477 1 15 1.44772 15 2C15 2.55228 15.4477 3 16 3Z" />
      <path d="M2 3C2.55228 3 3 2.55228 3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3Z" />
      <path
        d="M9 3C9.55228 3 10 2.55228 10 2C10 1.44772 9.55228 1 9 1C8.44772 1 8 1.44772 8 2C8 2.55228 8.44772 3 9 3Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 3C16.5523 3 17 2.55228 17 2C17 1.44772 16.5523 1 16 1C15.4477 1 15 1.44772 15 2C15 2.55228 15.4477 3 16 3Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 3C2.55228 3 3 2.55228 3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  PaperClip: (props: IconProps) => (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M19.1527 9.89948L10.1371 18.9151C8.08686 20.9653 4.76275 20.9653 2.71249 18.9151C0.662241 16.8648 0.662242 13.5407 2.71249 11.4905L11.7281 2.47486C13.0949 1.10803 15.311 1.10803 16.6779 2.47486C18.0447 3.8417 18.0447 6.05778 16.6779 7.42461L8.01579 16.0867C7.33238 16.7701 6.22434 16.7701 5.54092 16.0867C4.8575 15.4033 4.8575 14.2952 5.54092 13.6118L13.1423 6.0104"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  File: (props: IconProps) => (
    <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M11 10H5M7 14H5M13 6H5M17 5.8V16.2C17 17.8802 17 18.7202 16.673 19.362C16.3854 19.9265 15.9265 20.3854 15.362 20.673C14.7202 21 13.8802 21 12.2 21H5.8C4.11984 21 3.27976 21 2.63803 20.673C2.07354 20.3854 1.6146 19.9265 1.32698 19.362C1 18.7202 1 17.8802 1 16.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H12.2C13.8802 1 14.7202 1 15.362 1.32698C15.9265 1.6146 16.3854 2.07354 16.673 2.63803C17 3.27976 17 4.11984 17 5.8Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  XCircle: (props: IconProps) => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M14 8L8 14M8 8L14 14M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        strokeWidth={props.strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Trash: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M7 1H13M1 4H19M17 4L16.2987 14.5193C16.1935 16.0975 16.1409 16.8867 15.8 17.485C15.4999 18.0118 15.0472 18.4353 14.5017 18.6997C13.882 19 13.0911 19 11.5093 19H8.49065C6.90891 19 6.11803 19 5.49834 18.6997C4.95276 18.4353 4.50009 18.0118 4.19998 17.485C3.85911 16.8867 3.8065 16.0975 3.70129 14.5193L3 4M8 8.5V13.5M12 8.5V13.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  LogIn04: (props: IconProps) => (
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M10 7L14 11M14 11L10 15M14 11H1M1.33782 6C3.06687 3.01099 6.29859 1 10 1C15.5228 1 20 5.47715 20 11C20 16.5228 15.5228 21 10 21C6.29859 21 3.06687 18.989 1.33782 16"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ChevronDown: (props: IconProps) => (
    <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path d="M7.75 0.875L4.5 4.125L1.25 0.875" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  ChevronUp: (props: IconProps) => (
    <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path d="M1.25 4.125L4.5 0.875L7.75 4.125" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  X: (props: IconProps) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path d="M11 1L1 11M1 1L11 11" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  CheckCircleBroken: (props: IconProps) => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M21 10.0857V11.0057C20.9988 13.1621 20.3005 15.2604 19.0093 16.9875C17.7182 18.7147 15.9033 19.9782 13.8354 20.5896C11.7674 21.201 9.55726 21.1276 7.53447 20.3803C5.51168 19.633 3.78465 18.2518 2.61096 16.4428C1.43727 14.6338 0.879791 12.4938 1.02168 10.342C1.16356 8.19029 1.99721 6.14205 3.39828 4.5028C4.79935 2.86354 6.69279 1.72111 8.79619 1.24587C10.8996 0.770634 13.1003 0.988061 15.07 1.86572M21 3L11 13.01L8 10.01"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  CheckCircle: (props: IconProps) => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M6.5 11L9.5 14L15.5 8M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        strokeWidth={props.strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Check: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M20 6L9 17L4 12" strokeWidth={props.strokeWidth || 1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Plus: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path d="M12 5V19M5 12H19" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Download: (props: IconProps) => (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
    </svg>
  ),
  Upload: (props: IconProps) => (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" />
    </svg>
  ),
  Laptop: (props: IconProps) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M15.75 12V5.4C15.75 4.55992 15.75 4.13988 15.5865 3.81901C15.4427 3.53677 15.2132 3.3073 14.931 3.16349C14.6101 3 14.1901 3 13.35 3H4.65C3.80992 3 3.38988 3 3.06901 3.16349C2.78677 3.3073 2.5573 3.53677 2.41349 3.81901C2.25 4.13988 2.25 4.55992 2.25 5.4V12M3.5 15H14.5C14.965 15 15.1975 15 15.3882 14.9489C15.9059 14.8102 16.3102 14.4059 16.4489 13.8882C16.5 13.6975 16.5 13.465 16.5 13C16.5 12.7675 16.5 12.6513 16.4744 12.5559C16.4051 12.2971 16.2029 12.0949 15.9441 12.0256C15.8487 12 15.7325 12 15.5 12H2.5C2.26751 12 2.15126 12 2.05589 12.0256C1.79707 12.0949 1.59491 12.2971 1.52556 12.5559C1.5 12.6513 1.5 12.7675 1.5 13C1.5 13.465 1.5 13.6975 1.55111 13.8882C1.68981 14.4059 2.09413 14.8102 2.61177 14.9489C2.80252 15 3.03501 15 3.5 15Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  World: (props: IconProps) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M2.30699 5.61212L5.52302 7.90924C5.69036 8.02877 5.77404 8.08854 5.86161 8.10231C5.93866 8.11442 6.01758 8.10221 6.08736 8.06737C6.16668 8.02778 6.22837 7.94552 6.35176 7.781L7.03134 6.87489C7.06623 6.82836 7.08367 6.8051 7.10418 6.78503C7.12239 6.76722 7.14236 6.7513 7.1638 6.73753C7.18794 6.72203 7.21451 6.71022 7.26765 6.6866L10.1691 5.39707C10.2894 5.34361 10.3495 5.31688 10.3949 5.27514C10.435 5.23822 10.4665 5.193 10.4874 5.14263C10.511 5.08568 10.5153 5.02002 10.5241 4.88869L10.7365 1.70205M10.125 10.125L12.087 10.9659C12.3146 11.0634 12.4285 11.1122 12.4888 11.1932C12.5417 11.2643 12.5677 11.3518 12.5622 11.4403C12.556 11.5411 12.4873 11.6441 12.3499 11.8502L11.4281 13.2328C11.363 13.3305 11.3304 13.3794 11.2874 13.4147C11.2493 13.446 11.2054 13.4695 11.1583 13.4838C11.105 13.5 11.0463 13.5 10.9289 13.5H9.43246C9.27695 13.5 9.19919 13.5 9.13303 13.474C9.07461 13.451 9.02289 13.4137 8.98262 13.3656C8.93701 13.311 8.91242 13.2373 8.86325 13.0897L8.32859 11.4858C8.29959 11.3988 8.28508 11.3553 8.28127 11.311C8.27788 11.2718 8.28069 11.2323 8.28958 11.194C8.29962 11.1508 8.32013 11.1097 8.36115 11.0277L8.76728 10.2154C8.8498 10.0504 8.89106 9.96789 8.95461 9.91666C9.01061 9.87151 9.07842 9.84342 9.14994 9.83575C9.23111 9.82704 9.31863 9.85621 9.49367 9.91456L10.125 10.125ZM16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  House: (props: IconProps) => (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M5 12.75H11M7.26327 2.07306L2.17654 6.0294C1.83652 6.29387 1.6665 6.4261 1.54402 6.5917C1.43552 6.73839 1.3547 6.90365 1.30552 7.07935C1.25 7.2777 1.25 7.49308 1.25 7.92385V13.35C1.25 14.1901 1.25 14.6102 1.41349 14.931C1.5573 15.2133 1.78677 15.4427 2.06901 15.5866C2.38988 15.75 2.80992 15.75 3.65 15.75H12.35C13.1901 15.75 13.6101 15.75 13.931 15.5866C14.2132 15.4427 14.4427 15.2133 14.5865 14.931C14.75 14.6102 14.75 14.1901 14.75 13.35V7.92385C14.75 7.49308 14.75 7.2777 14.6945 7.07935C14.6453 6.90365 14.5645 6.73839 14.456 6.5917C14.3335 6.4261 14.1635 6.29387 13.8235 6.02941L8.73673 2.07306C8.47324 1.86812 8.34149 1.76565 8.19601 1.72626C8.06765 1.69151 7.93235 1.69151 7.80399 1.72626C7.65851 1.76565 7.52677 1.86812 7.26327 2.07306Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  VisaCardLogo: (props: IconProps) => (
    <svg width="46" height="32" viewBox="0 0 46 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      {props.title && <title>{props.title}</title>}
      <rect x="0.5" y="0.5" width="45" height="31" rx="5.5" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3336 21.1443H11.5872L9.52784 13.0565C9.43009 12.6845 9.22255 12.3556 8.91725 12.2005C8.15535 11.811 7.31579 11.5009 6.3999 11.3446V11.0332H10.824C11.4346 11.0332 11.8925 11.5009 11.9689 12.0442L13.0374 17.8782L15.7824 11.0332H18.4524L14.3336 21.1443ZM19.9789 21.1443H17.3852L19.5209 11.0332H22.1146L19.9789 21.1443ZM25.4702 13.8343C25.5465 13.2897 26.0044 12.9783 26.5387 12.9783C27.3783 12.9001 28.2928 13.0565 29.0561 13.4447L29.514 11.2677C28.7508 10.9564 27.9112 10.8 27.1493 10.8C24.6319 10.8 22.8002 12.2005 22.8002 14.1443C22.8002 15.623 24.0977 16.3995 25.0136 16.8672C26.0044 17.3336 26.3861 17.645 26.3097 18.1114C26.3097 18.811 25.5465 19.1224 24.7846 19.1224C23.8687 19.1224 22.9528 18.8892 22.1146 18.4996L21.6567 20.6779C22.5725 21.0662 23.5634 21.2225 24.4793 21.2225C27.3019 21.2994 29.0561 19.9002 29.0561 17.8C29.0561 15.1553 25.4702 15.0003 25.4702 13.8343ZM38.1332 21.1443L36.0738 11.0332H33.8618C33.4038 11.0332 32.9459 11.3446 32.7932 11.811L28.9797 21.1443H31.6497L32.1826 19.667H35.4632L35.7685 21.1443H38.1332ZM34.2434 13.7561L35.0053 17.5668H32.8696L34.2434 13.7561Z"
        fill="#172B85"
      />
      <rect x="0.5" y="0.5" width="45" height="31" rx="5.5" stroke="#F2F4F7" />
    </svg>
  ),
  MasterCardLogo: (props: IconProps) => (
    <svg width="46" height="32" viewBox="0 0 46 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      {props.title && <title>{props.title}</title>}
      <rect x="0.5" y="0.5" width="45" height="31" rx="5.5" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9053 22.4392C21.3266 23.77 19.2787 24.5733 17.0409 24.5733C12.0478 24.5733 8 20.5737 8 15.64C8 10.7062 12.0478 6.70662 17.0409 6.70662C19.2787 6.70662 21.3266 7.50996 22.9053 8.84068C24.484 7.50996 26.5319 6.70662 28.7697 6.70662C33.7628 6.70662 37.8106 10.7062 37.8106 15.64C37.8106 20.5737 33.7628 24.5733 28.7697 24.5733C26.5319 24.5733 24.484 23.77 22.9053 22.4392Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9053 22.4392C24.8492 20.8007 26.0818 18.3626 26.0818 15.64C26.0818 12.9174 24.8492 10.4792 22.9053 8.84068C24.484 7.50995 26.5319 6.70662 28.7697 6.70662C33.7628 6.70662 37.8106 10.7062 37.8106 15.64C37.8106 20.5737 33.7628 24.5733 28.7697 24.5733C26.5319 24.5733 24.484 23.77 22.9053 22.4392Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9055 22.4392C24.8494 20.8007 26.082 18.3626 26.082 15.64C26.082 12.9174 24.8494 10.4793 22.9055 8.84072C20.9616 10.4793 19.729 12.9174 19.729 15.64C19.729 18.3626 20.9616 20.8007 22.9055 22.4392Z"
        fill="#FF5E00"
      />
      <rect x="0.5" y="0.5" width="45" height="31" rx="5.5" stroke="#F2F4F7" />
    </svg>
  ),
  AmericanExpressLogo: () => (
    <svg height="16" viewBox="0 0 24 16" width="24" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fill-rule="evenodd">
        <rect fill="#016fd0" height="16" rx="2" width="24" />
        <path
          d="m13.7640663 13.3938564v-5.70139231l10.1475359.00910497v1.57489503l-1.1728619 1.25339231 1.1728619 1.2648839v1.6083094h-1.8726188l-.9951823-1.0981657-.9881105 1.1023204z"
          fill="#fffffe"
        />
        <path
          d="m14.4418122 12.7687956v-4.448884h3.7722872v1.02488398h-2.550895v.69569062h2.4900774v1.0078232h-2.4900774v.6833149h2.550895v1.0371713z"
          fill="#016fd0"
        />
        <path
          d="m18.1952707 12.7687956 2.087337-2.2270055-2.0874254-2.2217901h1.6156464l1.2754917 1.41003315 1.2791161-1.41003315h1.5461657v.03500552l-2.0428729 2.18678458 2.0428729 2.1638895v.063116h-1.5617237l-1.2981216-1.4241768-1.2847735 1.4241768z"
          fill="#016fd0"
        />
        <path
          d="m14.2373481 2.6319558h2.4460552l.8591381 1.95085083v-1.95085083h3.0198453l.5207514 1.46156906.5225194-1.46156906h2.3059447v5.70139227h-12.1865193z"
          fill="#fffffe"
        />
        <g fill="#016fd0">
          <path d="m14.7004641 3.25135912-1.9740111 4.44517127h1.3539006l.3724199-.89016575h2.0179447l.3721547.89016575h1.3875801l-1.96579-4.44517127zm.1696353 2.55743646.592-1.41507182.5915581 1.41507182z" />
          <path d="m18.2119779 7.69573481v-4.44508288l1.903116.00654144.9792707 2.73272928.9856354-2.73927072h1.8316022v4.44508288l-1.1786077.01043094v-3.05334807l-1.1125746 3.04291713h-1.0758011l-1.1356464-3.05334807v3.05334807z" />
        </g>
      </g>
    </svg>
  ),
  AffirmLogo: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="429" height="171" fill="none" viewBox="0 0 429 171">
      <g clipPath="url(#clip0_2525_303)">
        <path
          fill="#000"
          fillRule="evenodd"
          d="M28.1 156.27c-5.3 0-8-2.61-8-6.9 0-8 8.92-10.69 25.19-12.42 0 10.66-7.21 19.32-17.24 19.32h.05zm7-59.95c-11.63 0-25 5.47-32.26 11.26l6.63 14c5.82-5.33 15.23-9.89 23.72-9.89 8.07 0 12.53 2.7 12.53 8.14 0 3.65-2.95 5.5-8.53 6.23-20.86 2.7-37.21 8.46-37.21 24.53 0 12.74 9.07 20.45 23.24 20.45 10.12 0 19.12-5.62 23.4-13v11h18.86v-46.09c0-19-13.19-26.67-30.37-26.67l-.01.04zM224.39 98.39v70.56h20.18v-34c0-16.15 9.78-20.9 16.59-20.9a15.473 15.473 0 018.63 2.55l3.69-18.65a22.842 22.842 0 00-9-1.63c-10.37 0-16.89 4.59-21.19 13.93V98.39h-18.9zM367 96.32c-10.67 0-18.65 6.3-22.8 12.38-3.85-7.85-12-12.38-21.8-12.38-10.66 0-18.05 5.92-21.46 12.74V98.39h-19.46v70.56h20.2v-36.33c0-13 6.83-19.29 13.2-19.29 5.77 0 11.07 3.73 11.07 13.36v42.26h20.16v-36.33c0-13.19 6.66-19.29 13.33-19.29 5.34 0 11 3.88 11 13.22v42.4h20.16v-48.78c0-15.85-10.67-23.85-23.56-23.85M175.28 98.39H157v-7.17c0-9.34 5.33-12 9.92-12a20.18 20.18 0 019 2.25l6.22-14.23s-6.31-4.12-17.78-4.12c-12.89 0-27.56 7.27-27.56 30.08v5.19h-30.55v-7.17c0-9.34 5.32-12 9.92-12 3.139 0 6.23.773 9 2.25l6.22-14.23c-3.71-2.17-9.68-4.12-17.77-4.12-12.89 0-27.56 7.27-27.56 30.08v5.19H74.38v15.56h11.71v55h20.16v-55h30.59v55H157v-55h18.28V98.39z"
          clipRule="evenodd"
        ></path>
        <path fill="#000" d="M207.46 98.39h-20.14v70.53h20.14V98.39z"></path>
        <path
          fill="#4A4AF4"
          fillRule="evenodd"
          d="M188.06 86.4h19.73c11.51-36.19 50.56-68 97-68 56.48 0 105.29 43 105.29 109.94a137.585 137.585 0 01-5.6 40.61h19.15l.19-.66a162.189 162.189 0 004.74-39.89C428.56 53.75 374.16.02 304.83.02c-54.46 0-103 37.8-116.76 86.4l-.01-.02z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2525_303">
          <path fill="#fff" d="M0 0H428.55V171H0z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
  AfterPayLogo: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1869.6 838.5"
      xmlSpace="preserve"
      {...props}
    >
      <style type="text/css">{'\n    .st0 {\n      fill: #B2FCE4;\n    }\n  '}</style>
      <g id="Afterpay_Badge_Bg">
        <g>
          <path
            className="st0"
            d="M1450.3,694.5H419.2c-152,0-275.2-123.2-275.2-275.2v0c0-152,123.2-275.2,275.2-275.2h1031.1 c152,0,275.2,123.2,275.2,275.2v0C1725.6,571.2,1602.3,694.5,1450.3,694.5z"
          />
        </g>
      </g>
      <g id="Afterpay_Logo_Black">
        <g>
          <path d="M1492,353.5l-34.6-19.8l-35.1-20.1c-23.2-13.3-52.2,3.4-52.2,30.2v4.5c0,2.5,1.3,4.8,3.5,6l16.3,9.3 c4.5,2.6,10.1-0.7,10.1-5.9V347c0-5.3,5.7-8.6,10.3-6l32,18.4l31.9,18.3c4.6,2.6,4.6,9.3,0,11.9l-31.9,18.3l-32,18.4 c-4.6,2.6-10.3-0.7-10.3-6l0-5.3c0-26.8-29-43.6-52.2-30.2l-35.1,20.1l-34.6,19.8c-23.3,13.4-23.3,47.1,0,60.5l34.6,19.8 l35.1,20.1c23.2,13.3,52.2-3.4,52.2-30.2v-4.5c0-2.5-1.3-4.8-3.5-6l-16.3-9.3c-4.5-2.6-10.1,0.7-10.1,5.9v10.7 c0,5.3-5.7,8.6-10.3,6l-32-18.4l-31.9-18.3c-4.6-2.6-4.6-9.3,0-11.9l31.9-18.3l32-18.4c4.6-2.6,10.3,0.7,10.3,6v5.3 c0,26.8,29,43.6,52.2,30.2l35.1-20.1l34.6-19.8C1515.3,400.5,1515.3,366.9,1492,353.5z" />
          <g>
            <path d="M1265,360.1L1184,527.4h-33.6l30.3-62.5L1133,360.1h34.5l30.6,70.2l33.4-70.2H1265z" />
          </g>
          <g>
            <g>
              <path d="M455.1,419.5c0-20-14.5-34-32.3-34s-32.3,14.3-32.3,34c0,19.5,14.5,34,32.3,34S455.1,439.5,455.1,419.5 M455.4,478.9 v-15.4c-8.8,10.7-21.9,17.3-37.5,17.3c-32.6,0-57.3-26.1-57.3-61.3c0-34.9,25.7-61.5,58-61.5c15.2,0,28,6.7,36.8,17.1v-15h29.2 v118.8H455.4z" />
              <path d="M626.6,452.5c-10.2,0-13.1-3.8-13.1-13.8V386h18.8v-25.9h-18.8v-29h-29.9v29H545v-11.8c0-10,3.8-13.8,14.3-13.8h6.6v-23 h-14.4c-24.7,0-36.4,8.1-36.4,32.8v15.9h-16.6V386h16.6v92.9H545V386h38.6v58.2c0,24.2,9.3,34.7,33.5,34.7h15.4v-26.4H626.6z" />
              <path d="M734,408.8c-2.1-15.4-14.7-24.7-29.5-24.7c-14.7,0-26.9,9-29.9,24.7H734z M674.3,427.3c2.1,17.6,14.7,27.6,30.7,27.6 c12.6,0,22.3-5.9,28-15.4h30.7c-7.1,25.2-29.7,41.3-59.4,41.3c-35.9,0-61.1-25.2-61.1-61.1c0-35.9,26.6-61.8,61.8-61.8 c35.4,0,61.1,26.1,61.1,61.8c0,2.6-0.2,5.2-0.7,7.6H674.3z" />
              <path d="M956.5,419.5c0-19.2-14.5-34-32.3-34c-17.8,0-32.3,14.3-32.3,34c0,19.5,14.5,34,32.3,34 C942,453.5,956.5,438.8,956.5,419.5 M862.4,527.4V360.1h29.2v15.4c8.8-10.9,21.9-17.6,37.5-17.6c32.1,0,57.3,26.4,57.3,61.3 c0,34.9-25.7,61.5-58,61.5c-15,0-27.3-5.9-35.9-15.9v62.5H862.4z" />
              <path d="M1091.7,419.5c0-20-14.5-34-32.3-34c-17.8,0-32.3,14.3-32.3,34c0,19.5,14.5,34,32.3,34 C1077.2,453.5,1091.7,439.5,1091.7,419.5 M1092,478.9v-15.4c-8.8,10.7-21.9,17.3-37.5,17.3c-32.6,0-57.3-26.1-57.3-61.3 c0-34.9,25.7-61.5,58-61.5c15.2,0,28,6.7,36.8,17.1v-15h29.2v118.8H1092z" />
              <path d="M809.7,371.7c0,0,7.4-13.8,25.7-13.8c7.8,0,12.8,2.7,12.8,2.7v30.3c0,0-11-6.8-21.1-5.4c-10.1,1.4-16.5,10.6-16.5,23 v70.3h-30.2V360.1h29.2V371.7z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  Eye: (props: IconProps) => (
    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.42012 8.71318C1.28394 8.49754 1.21584 8.38972 1.17772 8.22342C1.14909 8.0985 1.14909 7.9015 1.17772 7.77658C1.21584 7.61028 1.28394 7.50246 1.42012 7.28682C2.54553 5.50484 5.8954 1 11.0004 1C16.1054 1 19.4553 5.50484 20.5807 7.28682C20.7169 7.50246 20.785 7.61028 20.8231 7.77658C20.8517 7.9015 20.8517 8.0985 20.8231 8.22342C20.785 8.38972 20.7169 8.49754 20.5807 8.71318C19.4553 10.4952 16.1054 15 11.0004 15C5.8954 15 2.54553 10.4952 1.42012 8.71318Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={props.color}
      />
      <path
        d="M11.0004 11C12.6573 11 14.0004 9.65685 14.0004 8C14.0004 6.34315 12.6573 5 11.0004 5C9.34355 5 8.0004 6.34315 8.0004 8C8.0004 9.65685 9.34355 11 11.0004 11Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={props.color}
      />
    </svg>
  ),
  EyeOff: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213"
        stroke="#1D252C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ThumbsDown: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22 4H20C19.45 4 19 4.45 19 5V14C19 14.55 19.45 15 20 15H22V4ZM2.17 11.12C2.06 11.37 2 11.64 2 11.92V13C2 14.1 2.9 15 4 15H9.5L8.58 19.65C8.53 19.87 8.56 20.11 8.66 20.31C8.89 20.76 9.18 21.17 9.54 21.53L10 22L16.41 15.59C16.79 15.21 17 14.7 17 14.17V6.34C17 5.05 15.95 4 14.66 4H6.56C5.85 4 5.2 4.37 4.84 4.97L2.17 11.12Z"
        fill={props.color ?? '#D0D5DD'}
      />
    </svg>
  ),
  ThumbsUp: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2 20H4C4.55 20 5 19.55 5 19V10C5 9.45 4.55 9 4 9H2V20ZM21.83 12.88C21.94 12.63 22 12.36 22 12.08V11C22 9.9 21.1 9 20 9H14.5L15.42 4.35C15.47 4.13 15.44 3.89 15.34 3.69C15.1126 3.23961 14.8156 2.82789 14.46 2.47L14 2L7.59 8.41C7.21 8.79 7 9.3 7 9.83V17.67C7.00264 18.2889 7.25035 18.8815 7.6889 19.3182C8.12744 19.7548 8.72112 20 9.34 20H17.45C18.15 20 18.81 19.63 19.17 19.03L21.83 12.88Z"
        fill={props.color ?? '#D0D5DD'}
      />
    </svg>
  ),
  Calendar: (props: IconProps) => (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19 9H1M14 1V5M6 1V5M5.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  UploadCloud2: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 16L12 12M12 12L16 16M12 12V21M20 16.7428C21.2215 15.734 22 14.2079 22 12.5C22 9.46243 19.5376 7 16.5 7C16.2815 7 16.0771 6.886 15.9661 6.69774C14.6621 4.48484 12.2544 3 9.5 3C5.35786 3 2 6.35786 2 10.5C2 12.5661 2.83545 14.4371 4.18695 15.7935"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Loading01: (props: IconProps) => (
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11 1.25V3.75M11 17V21M4.75 11H1.25M20.25 11H18.75M17.4571 17.4571L16.75 16.75M17.6642 4.41579L16.25 5.83M3.92157 18.0784L6.75 15.25M4.12868 4.20868L6.25 6.33"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  FilePlus02: (props: IconProps) => (
    <svg width="38" height="44" viewBox="0 0 38 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M34 19V11.6C34 8.23969 34 6.55953 33.346 5.27606C32.7708 4.14708 31.8529 3.2292 30.7239 2.65396C29.4405 2 27.7603 2 24.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V32.4C2 35.7603 2 37.4405 2.65396 38.7239C3.2292 39.8529 4.14708 40.7708 5.27606 41.346C6.55953 42 8.23969 42 11.6 42H18M22 20H10M14 28H10M26 12H10M30 40V28M24 34H36"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Location02: (props: IconProps) => (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 26.5727C4.29728 28.2061 2 30.4823 2 33C2 37.9706 10.9543 42 22 42C33.0457 42 42 37.9706 42 33C42 30.4823 39.7027 28.2061 36 26.5727M34 14C34 22.1274 25 26 22 32C19 26 10 22.1274 10 14C10 7.37258 15.3726 2 22 2C28.6274 2 34 7.37258 34 14ZM24 14C24 15.1046 23.1046 16 22 16C20.8954 16 20 15.1046 20 14C20 12.8954 20.8954 12 22 12C23.1046 12 24 12.8954 24 14Z"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  CreditCardCheck: (props: IconProps) => (
    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.3332 12.0013L14.9998 13.668L18.3332 10.3346M18.3332 5.33464H1.6665M18.3332 7.0013V3.83464C18.3332 2.90122 18.3332 2.43451 18.1515 2.07799C17.9917 1.76438 17.7368 1.50941 17.4232 1.34963C17.0666 1.16797 16.5999 1.16797 15.6665 1.16797H4.33317C3.39975 1.16797 2.93304 1.16797 2.57652 1.34962C2.26292 1.50941 2.00795 1.76438 1.84816 2.07798C1.6665 2.4345 1.6665 2.90121 1.6665 3.83464V10.168C1.6665 11.1014 1.6665 11.5681 1.84816 11.9246C2.00795 12.2382 2.26292 12.4932 2.57652 12.653C2.93304 12.8346 3.39975 12.8346 4.33317 12.8346H9.99984"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Delivery: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.0833 6.06331L9.99997 9.9985M9.99997 9.9985L2.91664 6.06331M9.99997 9.9985L10 17.9152M17.5 13.3807V6.6164C17.5 6.33086 17.5 6.18809 17.4579 6.06076C17.4207 5.94811 17.3599 5.84471 17.2795 5.75747C17.1886 5.65885 17.0638 5.58952 16.8142 5.45085L10.6475 2.02493C10.4112 1.89363 10.293 1.82798 10.1679 1.80224C10.0571 1.77946 9.94288 1.77946 9.83213 1.80224C9.70698 1.82798 9.58881 1.89363 9.35248 2.02493L3.18581 5.45085C2.93621 5.58952 2.8114 5.65886 2.72053 5.75747C2.64013 5.84471 2.57929 5.94811 2.54207 6.06076C2.5 6.18809 2.5 6.33086 2.5 6.6164V13.3807C2.5 13.6662 2.5 13.809 2.54207 13.9363C2.57929 14.0489 2.64013 14.1523 2.72053 14.2396C2.8114 14.3382 2.93621 14.4075 3.18581 14.5462L9.35248 17.9721C9.58881 18.1034 9.70698 18.1691 9.83213 18.1948C9.94288 18.2176 10.0571 18.2176 10.1679 18.1948C10.293 18.1691 10.4112 18.1034 10.6475 17.9721L16.8142 14.5462C17.0638 14.4075 17.1886 14.3382 17.2795 14.2396C17.3599 14.1523 17.4207 14.0489 17.4579 13.9363C17.5 13.809 17.5 13.6662 17.5 13.3807Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  InfoCircle: (props: IconProps) => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        strokeWidth={props.strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Separator: (props: IconProps) => (
    <svg width="1" height="28" viewBox="0 0 1 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="1" height="28" fill="#475467" />
    </svg>
  ),
  Back: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15 6L9 12L15 18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  AddMultipleCustomer: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15.5H7.50001C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56046 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M19 21V15M16 18H22"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  FilterLines: (props: IconProps) => (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4 6H14M1.5 1H16.5M6.5 11H11.5" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  ForwardArrow: (props: IconProps) => (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1 13L7 7L1 1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Minus: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path d="M5 12H19" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Phone: (props: IconProps) => (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.38028 7.85335C7.07627 9.30297 8.02506 10.6616 9.22664 11.8632C10.4282 13.0648 11.7869 14.0136 13.2365 14.7096C13.3612 14.7694 13.4235 14.7994 13.5024 14.8224C13.7828 14.9041 14.127 14.8454 14.3644 14.6754C14.4313 14.6275 14.4884 14.5704 14.6027 14.4561C14.9523 14.1064 15.1271 13.9316 15.3029 13.8174C15.9658 13.3864 16.8204 13.3864 17.4833 13.8174C17.6591 13.9316 17.8339 14.1064 18.1835 14.4561L18.3783 14.6509C18.9098 15.1824 19.1755 15.4481 19.3198 15.7335C19.6069 16.301 19.6069 16.9713 19.3198 17.5389C19.1755 17.8242 18.9098 18.09 18.3783 18.6214L18.2207 18.779C17.6911 19.3087 17.4263 19.5735 17.0662 19.7757C16.6667 20.0001 16.0462 20.1615 15.588 20.1601C15.1751 20.1589 14.8928 20.0788 14.3284 19.9186C11.295 19.0576 8.43264 17.4332 6.04466 15.0452C3.65668 12.6572 2.03221 9.79483 1.17124 6.76144C1.01103 6.19699 0.930924 5.91477 0.929696 5.50182C0.928332 5.0436 1.08969 4.42311 1.31411 4.0236C1.51636 3.66357 1.78117 3.39876 2.3108 2.86913L2.46843 2.7115C2.99987 2.18006 3.2656 1.91433 3.55098 1.76999C4.11854 1.48292 4.7888 1.48292 5.35636 1.76999C5.64174 1.91433 5.90747 2.18006 6.43891 2.7115L6.63378 2.90637C6.98338 3.25597 7.15819 3.43078 7.27247 3.60655C7.70347 4.26945 7.70347 5.12403 7.27247 5.78692C7.15819 5.96269 6.98338 6.1375 6.63378 6.4871C6.51947 6.60142 6.46231 6.65857 6.41447 6.72538C6.24446 6.96281 6.18576 7.30707 6.26748 7.58743C6.29048 7.66632 6.32041 7.72866 6.38028 7.85335Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Settings01: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke="#1D252C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
        stroke="#1D252C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Refresh: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M20.453 12.893C20.1752 15.5029 18.6964 17.9487 16.2494 19.3614C12.1839 21.7086 6.98539 20.3157 4.63818 16.2502L4.38818 15.8172M3.54613 11.107C3.82393 8.49711 5.30272 6.05138 7.74971 4.63862C11.8152 2.29141 17.0137 3.68434 19.3609 7.74983L19.6109 8.18285M3.49316 18.0661L4.22521 15.334L6.95727 16.0661M17.0424 7.93401L19.7744 8.66606L20.5065 5.93401"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={props.color}
      />
    </svg>
  ),
  Circle: (props: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <circle cx="6" cy="6" r="6" fill={props.color} />
    </svg>
  ),
  Money: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7391_98302)">
        <path
          d="M7.08317 12.2235C7.08317 13.2974 7.95373 14.168 9.02762 14.168H10.8332C11.9838 14.168 12.9165 13.2352 12.9165 12.0846C12.9165 10.934 11.9838 10.0013 10.8332 10.0013H9.1665C8.01591 10.0013 7.08317 9.06856 7.08317 7.91797C7.08317 6.76738 8.01591 5.83464 9.1665 5.83464H10.9721C12.0459 5.83464 12.9165 6.70519 12.9165 7.77908M9.99984 4.58464V5.83464M9.99984 14.168V15.418M18.3332 10.0013C18.3332 14.6037 14.6022 18.3346 9.99984 18.3346C5.39746 18.3346 1.6665 14.6037 1.6665 10.0013C1.6665 5.39893 5.39746 1.66797 9.99984 1.66797C14.6022 1.66797 18.3332 5.39893 18.3332 10.0013Z"
          stroke="#344054"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7391_98302">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  SwitchHorizontal: (props: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M26.6663 22.6667H5.33301M5.33301 22.6667L10.6663 17.3333M5.33301 22.6667L10.6663 28M5.33301 9.33333H26.6663M26.6663 9.33333L21.333 4M26.6663 9.33333L21.333 14.6667"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Sparkle: (props: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
      />
    </svg>
  ),
  LinkExternal: (props: IconProps) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        {props.title && <title>{props.title}</title>}
        <path
          d="M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  CircleExclamation: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="10" cy="10" r="9" stroke="#FF8B00" strokeWidth="2" />
      <path d="M10 6V12" stroke="#FF8B00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 14H10.01" stroke="#FF8B00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Location01: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Store: (props: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 810 809.999993" height="24" {...props}>
      <path
        fill="#ffffff"
        d="M 795.496094 236.59375 L 742.554688 77.734375 C 727.058594 31.242188 683.746094 0.0429688 634.734375 0.0429688 L 175.265625 0.0429688 C 126.253906 0.0429688 82.941406 31.285156 67.445312 77.734375 L 14.503906 236.636719 C 0.246094 279.449219 12.769531 325.613281 43.394531 354.664062 L 43.394531 692.261719 C 43.394531 754.953125 94.347656 805.910156 157.039062 805.910156 L 652.960938 805.910156 C 715.652344 805.910156 766.605469 754.953125 766.605469 692.261719 L 766.605469 354.664062 C 797.1875 325.613281 809.753906 279.449219 795.496094 236.59375 Z M 312.015625 743.878906 L 312.015625 609.566406 C 312.015625 581.09375 335.199219 557.90625 363.671875 557.90625 L 446.328125 557.90625 C 474.800781 557.90625 497.984375 581.09375 497.984375 609.566406 L 497.984375 743.878906 Z M 704.617188 692.21875 C 704.617188 720.691406 681.433594 743.878906 652.960938 743.878906 L 559.972656 743.878906 L 559.972656 609.566406 C 559.972656 546.875 509.019531 495.917969 446.328125 495.917969 L 363.671875 495.917969 C 300.980469 495.917969 250.027344 546.875 250.027344 609.566406 L 250.027344 743.878906 L 157.039062 743.878906 C 128.566406 743.878906 105.382812 720.691406 105.382812 692.21875 L 105.382812 385.699219 C 155.84375 398.015625 215.0625 391.734375 256.265625 366.8125 C 271.515625 357.597656 290.566406 357.597656 305.859375 366.8125 C 361.027344 400.039062 448.929688 400.039062 504.101562 366.8125 C 519.390625 357.558594 538.441406 357.597656 553.734375 366.8125 C 581.300781 383.425781 616.550781 392.601562 652.960938 392.601562 C 670.855469 392.601562 688.210938 390.246094 704.617188 386.113281 Z M 714.660156 316.851562 C 678.042969 335.738281 619.855469 334.332031 585.761719 313.75 C 568.238281 303.171875 548.609375 297.882812 528.9375 297.882812 C 509.265625 297.882812 489.636719 303.171875 472.113281 313.710938 C 435.996094 335.488281 374.003906 335.488281 337.886719 313.710938 C 302.800781 292.59375 259.28125 292.632812 224.238281 313.710938 C 190.144531 334.25 131.957031 335.652344 95.339844 316.808594 C 74.757812 306.1875 65.296875 280.109375 73.273438 256.140625 L 126.210938 97.28125 C 133.238281 76.164062 152.949219 61.949219 175.222656 61.949219 L 634.652344 61.949219 C 656.925781 61.949219 676.640625 76.164062 683.664062 97.28125 L 736.605469 256.140625 C 744.582031 280.152344 735.117188 306.1875 714.578125 316.808594 Z M 714.660156 316.851562 "
      />
    </svg>
  ),
  Tool02: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M6 6L10.5 10.5M6 6H3L2 3L3 2L6 3V6ZM19.259 2.74101L16.6314 5.36863C16.2354 5.76465 16.0373 5.96265 15.9632 6.19098C15.8979 6.39183 15.8979 6.60817 15.9632 6.80902C16.0373 7.03735 16.2354 7.23535 16.6314 7.63137L16.8686 7.86863C17.2646 8.26465 17.4627 8.46265 17.691 8.53684C17.8918 8.6021 18.1082 8.6021 18.309 8.53684C18.5373 8.46265 18.7354 8.26465 19.1314 7.86863L21.5893 5.41072C21.854 6.05488 22 6.76039 22 7.5C22 10.5376 19.5376 13 16.5 13C16.1338 13 15.7759 12.9642 15.4298 12.8959C14.9436 12.8001 14.7005 12.7521 14.5532 12.7668C14.3965 12.7824 14.3193 12.8059 14.1805 12.8802C14.0499 12.9501 13.919 13.081 13.657 13.343L6.5 20.5C5.67157 21.3284 4.32843 21.3284 3.5 20.5C2.67157 19.6716 2.67157 18.3284 3.5 17.5L10.657 10.343C10.919 10.081 11.0499 9.95005 11.1198 9.81949C11.1941 9.68068 11.2176 9.60347 11.2332 9.44681C11.2479 9.29945 11.1999 9.05638 11.1041 8.57024C11.0358 8.22406 11 7.86621 11 7.5C11 4.46243 13.4624 2 16.5 2C17.5055 2 18.448 2.26982 19.259 2.74101ZM12.0001 14.9999L17.5 20.4999C18.3284 21.3283 19.6716 21.3283 20.5 20.4999C21.3284 19.6715 21.3284 18.3283 20.5 17.4999L15.9753 12.9753C15.655 12.945 15.3427 12.8872 15.0408 12.8043C14.6517 12.6975 14.2249 12.7751 13.9397 13.0603L12.0001 14.9999Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Truck: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M14 7H16.3373C16.5818 7 16.7041 7 16.8192 7.02763C16.9213 7.05213 17.0188 7.09253 17.1083 7.14736C17.2092 7.2092 17.2957 7.29568 17.4686 7.46863L21.5314 11.5314C21.7043 11.7043 21.7908 11.7908 21.8526 11.8917C21.9075 11.9812 21.9479 12.0787 21.9724 12.1808C22 12.2959 22 12.4182 22 12.6627V15.5C22 15.9659 22 16.1989 21.9239 16.3827C21.8224 16.6277 21.6277 16.8224 21.3827 16.9239C21.1989 17 20.9659 17 20.5 17M15.5 17H14M14 17V7.2C14 6.0799 14 5.51984 13.782 5.09202C13.5903 4.71569 13.2843 4.40973 12.908 4.21799C12.4802 4 11.9201 4 10.8 4H5.2C4.0799 4 3.51984 4 3.09202 4.21799C2.71569 4.40973 2.40973 4.71569 2.21799 5.09202C2 5.51984 2 6.0799 2 7.2V15C2 16.1046 2.89543 17 4 17M14 17H10M10 17C10 18.6569 8.65685 20 7 20C5.34315 20 4 18.6569 4 17M10 17C10 15.3431 8.65685 14 7 14C5.34315 14 4 15.3431 4 17M20.5 17.5C20.5 18.8807 19.3807 20 18 20C16.6193 20 15.5 18.8807 15.5 17.5C15.5 16.1193 16.6193 15 18 15C19.3807 15 20.5 16.1193 20.5 17.5Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  PlusCircle: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clip-path="url(#clip0_284_24464)">
        <path
          d="M9.99935 6.66663V13.3333M6.66602 9.99996H13.3327M18.3327 9.99996C18.3327 14.6023 14.6017 18.3333 9.99935 18.3333C5.39698 18.3333 1.66602 14.6023 1.66602 9.99996C1.66602 5.39759 5.39698 1.66663 9.99935 1.66663C14.6017 1.66663 18.3327 5.39759 18.3327 9.99996Z"
          stroke="#485467"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_284_24464">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  HelpCircle: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Envelope: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 512 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M0 128c0-35.35 28.65-64 64-64h384c35.3 0 64 28.65 64 64v256c0 35.3-28.7 64-64 64H64c-35.35 0-64-28.7-64-64V128zm48 0v22.1l172.5 141.6c20.6 17 50.4 17 71 0L464 150.1v-23c0-7.9-7.2-16-16-16H64c-8.84 0-16 8.1-16 16v.9zm0 84.2V384c0 8.8 7.16 16 16 16h384c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.6 31.5-132.9 0L48 212.2z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Refer: (props: IconProps) => (
    <svg width="22" height="22" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.5935 9.45565C15.7766 9.29872 15.8682 9.22025 15.9017 9.12687C15.9311 9.04492 15.9311 8.95527 15.9017 8.87332C15.8682 8.77995 15.7766 8.70148 15.5935 8.54454L9.24047 3.09908C8.9253 2.82893 8.76772 2.69385 8.6343 2.69055C8.51835 2.68767 8.40759 2.73861 8.33432 2.82852C8.25 2.93197 8.25 3.13952 8.25 3.55463V6.77607C6.64899 7.05616 5.1837 7.86741 4.09478 9.0855C2.90762 10.4135 2.25093 12.1321 2.25 13.9133V14.3723C3.03701 13.4242 4.01963 12.6575 5.13057 12.1245C6.11002 11.6547 7.16881 11.3763 8.25 11.303V14.4456C8.25 14.8607 8.25 15.0682 8.33432 15.1717C8.40759 15.2616 8.51835 15.3125 8.6343 15.3096C8.76772 15.3063 8.9253 15.1713 9.24047 14.9011L15.5935 9.45565Z"
        stroke="#FCFCFD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ArrowUp: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99935 15.8333V4.16666M9.99935 4.16666L4.16602 9.99999M9.99935 4.16666L15.8327 9.99999"
        stroke={props.color ?? 'black'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ArrowDown: (props: IconProps) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(180)"
    >
      <path
        d="M9.99935 15.8333V4.16666M9.99935 4.16666L4.16602 9.99999M9.99935 4.16666L15.8327 9.99999"
        stroke={props.color ?? 'black'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Unpaid: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 12.1333C7 13.1643 7.89543 14 9 14H10.8571C12.0406 14 13 13.1046 13 12C13 10.8954 12.0406 10 10.8571 10H9.14286C7.95939 10 7 9.10457 7 8C7 6.89543 7.95939 6 9.14286 6H11C12.1046 6 13 6.83574 13 7.86667M10 5V6M10 14V15"
        stroke="#F04438"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18"
        stroke="#F04438"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M15 15L18 18" stroke="#F04438" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 18L18 15" stroke="#F04438" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Paid: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 12.1333C7 13.1643 7.89543 14 9 14H10.8571C12.0406 14 13 13.1046 13 12C13 10.8954 12.0406 10 10.8571 10H9.14286C7.95939 10 7 9.10457 7 8C7 6.89543 7.95939 6 9.14286 6H11C12.1046 6 13 6.83574 13 7.86667M10 5V6M10 14V15"
        stroke="#12B76A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18"
        stroke="#12B76A"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M19 15L16 18L14.5 16.5"
        stroke="#12B76A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Warning: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.55739 3.32471C9.19933 2.2159 10.8002 2.2159 11.4421 3.32471L17.7181 14.1649C18.3613 15.2761 17.5596 16.6667 16.2757 16.6667H3.72385C2.43996 16.6667 1.6382 15.276 2.28147 14.1649L8.55739 3.32471Z"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7.5V10.8333"
        stroke={props.color}
        fill={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99935 14.1667C10.4596 14.1667 10.8327 13.7936 10.8327 13.3333C10.8327 12.8731 10.4596 12.5 9.99935 12.5C9.53911 12.5 9.16602 12.8731 9.16602 13.3333C9.16602 13.7936 9.53911 14.1667 9.99935 14.1667Z"
        fill={props.color}
        stroke={props.color}
      />
    </svg>
  ),
  Account: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.9231 2H4.07692C3.79131 2 3.51739 2.10536 3.31542 2.29289C3.11346 2.48043 3 2.73478 3 3V18L5.69231 16L7.84615 18L10 16L12.1538 18L14.3077 16L17 18V3C17 2.73478 16.8865 2.48043 16.6846 2.29289C16.4826 2.10536 16.2087 2 15.9231 2Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.5 11.5H9.5" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M10 8.5C10.8284 8.5 11.5 7.82843 11.5 7C11.5 6.17157 10.8284 5.5 10 5.5C9.17157 5.5 8.5 6.17157 8.5 7C8.5 7.82843 9.17157 8.5 10 8.5Z"
        stroke="#98A2B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.5 11.5H12.5" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Merge: (props: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M3 18C3 16.3431 4.34315 15 6 15C7.65685 15 9 16.3431 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18Z"
        strokeWidth="2"
      />
      <path
        d="M3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6Z"
        strokeWidth="2"
      />
      <path
        d="M15 18C15 16.3431 16.3431 15 18 15C19.6569 15 21 16.3431 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18Z"
        strokeWidth="2"
      />
      <path d="M6 9L6 15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18 15L18 11.6758C18 7.00178 16.9424 6 12.008 6L9 6" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  ShoppingBag2: (props: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M15.9996 8C15.9996 9.06087 15.5782 10.0783 14.828 10.8284C14.0779 11.5786 13.0605 12 11.9996 12C10.9387 12 9.92131 11.5786 9.17116 10.8284C8.42102 10.0783 7.99959 9.06087 7.99959 8M3.63281 7.40138L2.93281 15.8014C2.78243 17.6059 2.70724 18.5082 3.01227 19.2042C3.28027 19.8157 3.74462 20.3204 4.33177 20.6382C5.00006 21 5.90545 21 7.71623 21H16.283C18.0937 21 18.9991 21 19.6674 20.6382C20.2546 20.3204 20.7189 19.8157 20.9869 19.2042C21.2919 18.5082 21.2167 17.6059 21.0664 15.8014L20.3664 7.40138C20.237 5.84875 20.1723 5.07243 19.8285 4.48486C19.5257 3.96744 19.0748 3.5526 18.5341 3.29385C17.92 3 17.141 3 15.583 3L8.41623 3C6.85821 3 6.07921 3 5.4651 3.29384C4.92433 3.5526 4.47349 3.96744 4.17071 4.48486C3.82689 5.07243 3.76219 5.84875 3.63281 7.40138Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Printer: (props: IconProps) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        d="M13.5 5.25V3.9C13.5 3.05992 13.5 2.63988 13.3365 2.31901C13.1927 2.03677 12.9632 1.8073 12.681 1.66349C12.3601 1.5 11.9401 1.5 11.1 1.5H6.9C6.05992 1.5 5.63988 1.5 5.31901 1.66349C5.03677 1.8073 4.8073 2.03677 4.66349 2.31901C4.5 2.63988 4.5 3.05992 4.5 3.9V5.25M4.5 13.5C3.80252 13.5 3.45378 13.5 3.16766 13.4233C2.3912 13.2153 1.78472 12.6088 1.57667 11.8323C1.5 11.5462 1.5 11.1975 1.5 10.5V8.85C1.5 7.58988 1.5 6.95982 1.74524 6.47852C1.96095 6.05516 2.30516 5.71095 2.72852 5.49524C3.20982 5.25 3.83988 5.25 5.1 5.25H12.9C14.1601 5.25 14.7902 5.25 15.2715 5.49524C15.6948 5.71095 16.039 6.05516 16.2548 6.47852C16.5 6.95982 16.5 7.58988 16.5 8.85V10.5C16.5 11.1975 16.5 11.5462 16.4233 11.8323C16.2153 12.6088 15.6088 13.2153 14.8323 13.4233C14.5462 13.5 14.1975 13.5 13.5 13.5M11.25 7.875H13.5M6.9 16.5H11.1C11.9401 16.5 12.3601 16.5 12.681 16.3365C12.9632 16.1927 13.1927 15.9632 13.3365 15.681C13.5 15.3601 13.5 14.9401 13.5 14.1V12.9C13.5 12.0599 13.5 11.6399 13.3365 11.319C13.1927 11.0368 12.9632 10.8073 12.681 10.6635C12.3601 10.5 11.9401 10.5 11.1 10.5H6.9C6.05992 10.5 5.63988 10.5 5.31901 10.6635C5.03677 10.8073 4.8073 11.0368 4.66349 11.319C4.5 11.6399 4.5 12.0599 4.5 12.9V14.1C4.5 14.9401 4.5 15.3601 4.66349 15.681C4.8073 15.9632 5.03677 16.1927 5.31901 16.3365C5.63988 16.5 6.05992 16.5 6.9 16.5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Calculator: (props: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
        <rect width="16" height="20" x="4" y="2" rx="2" />
        <path d="M8 6h8m0 8v4m0-8h.01M12 10h.01M8 10h.01M12 14h.01M8 14h.01M12 18h.01M8 18h.01" />
      </g>
    </svg>
  ),
  Google: (props: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props} stroke="none">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
    </svg>
  ),
} as const;

export default Icons;
export type IconNames = keyof typeof Icons;
